import { useMemo } from 'react';

import useClientState from '@/state/useClientState';

/**
 * V2 helper that returns current MwdWerklijn[] in state and matching dimensions.
 */
const useWerklijnen = () => {
  /**
   * Alle werklijnen die getransformeerd zijn naar het front-end formaat met alle berekeningen van dien.
   * De orginele data komt uit state.werklijnenMap en de data zoals die uit de api komt staat in state.werklijnen.
   * Ooit zullen die samengevoegd worden tot 1 formaat.
   */
  const werklijnenMap = useClientState((state) => state.werklijnenMap);
  const miniWerklijnenMap = useClientState((state) => state.miniWerklijnenMap);
  const mwd = useClientState((state) => state.mwd);

  const werklijnen = useMemo(() => Array.from(werklijnenMap.values()), [werklijnenMap]);
  const miniWerklijnen = useMemo(() => Array.from(miniWerklijnenMap.values()), [miniWerklijnenMap]);

  return {
    mwd,
    werklijnen,
    werklijnenMap,
    miniWerklijnen,
  };
};
export default useWerklijnen;
